<template>
  <section id="adaptive">
    <div
      v-if="graph.nodes && graph.nodes.length > 0"
      class="w-full flex justify-center"
    >
      <LearningMapTeacher
        ref="learningMap"
        :node="graph"
        :role="role"
        @onAddChapter="$emit('onAddChapter', $event, $refs['learningMap'])"
        @onAddObjective="$emit('onAddObjective', $event)"
        @onEditObjective="$emit('onEditObjective', $event)"
        @onShowObjects="$emit('onShowObjects', $event)"
        @onShowBlacklist="$emit('onShowBlacklist', $event)"
      />
    </div>
    <div
      v-else
      class="w-full h-[680px] relative flex flex-col justify-center items-center space-y-4"
    >
      <img src="@/assets/images/empty/empty-graphs.svg" alt="" />
      <p class="text-gray-600 w-[360px] text-center">
        {{
          $t("labels.generic", {
            pt: "Você visualizará aqui o grafo do seu curso, clique em “Adicionar Capítulo”.",
            en: "You will see the graph of your course here, click on “Add Chapter” ",
          })
        }}
      </p>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "adaptiveChapters",
  emits: [
    "onAddChapter",
    "onAddObjective",
    "onEditObjective",
    "onShowObjects",
    "onShowBlacklist",
  ],
  props: {
    role: [String],
    graph: { type: Object as PropType<any>, default: {} },
  },
});
</script>
